import $ from 'jquery'
import Tooltip from 'bootstrap/js/dist/tooltip'

import {
    uam,
    sentryAPIErrorV2,
    protectedApiCall,
    funnelUpdate,
} from './module_common';

const dataAddTitle = 'add-title'
const dataRemoveTitle = 'remove-title'
const dataElementId = 'elementid'

// used also in css
export const addClass = 'active'
export const removeClass = 'selected'
export const addAction = 'add'
export const removeAction = 'remove'

function updateCardFavourite(element, updateUIfunction, cType) {
    const contId = getFavouriteElementId(element)
    const currentAction = getCurrentAction(element)

    var url
    var funnels
    switch (cType) {
        case 'book':
            url = uam('/users/xxx/favourites/' + contId);
            funnels = {
                add: 'book_added_to_library',
                remove: 'book_removed_from_library' 
            };
            break;
        case 'article':
            url = uam('/users/xxx/articles/favourites/' + contId);
            funnels = {
                add: 'article_added_to_library',
                remove: 'article_removed_from_library' 
            };
            break;
    }

    let method, newAction;
    let funnelEvent = "";

    method = "POST";
    newAction = removeAction;
    funnelEvent = funnels.add;

    if (currentAction === removeAction) {
        method = "DELETE";
        newAction = addAction;
        funnelEvent = funnels.remove;
    }

    protectedApiCall(method, url, {},
        function () {
            funnelUpdate(funnelEvent);
            updateUIfunction(element, newAction, contId)
            
            // onLibraryPageFavouriteRemoved defined only in library.js, global
            // remove card from swiper carousel
            if (typeof onLibraryPageFavouriteRemoved === "function" && funnelEvent == funnels.remove){
                onLibraryPageFavouriteRemoved(contId, cType)
            }
            if (typeof onLibraryPageFavouriteAdd === "function" && funnelEvent == funnels.add){
                onLibraryPageFavouriteAdd(contId, cType)
            }
            
        }, function (err) {
            const contextData = {
                apicalldata:{
                    function: "updateCardFavourite",
                    contType: cType,
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error add/remove favourite for card')
            error.name = 'updateCardFavourite fail'
            sentryAPIErrorV2(error, contextData);
        }
    );
}

const favouriteCardClass = "add-favourite-attach-clk"
const favouriteCardMobileClass = "add-to-fav-mobile-attach-clk"

const favouriteArticleCardClass = "add-favourite-article-attach-clk"
const favouriteArticleCardMobileClass = "add-to-fav-article-mobile-attach-clk"

function manageFavouriteCardClick(e){
    e.stopPropagation()
    e.preventDefault()
    const currentTarget = $(e.currentTarget)
    updateCardFavourite(currentTarget, updateCardFavouriteUI, 'book')
}

function manageFavouriteCardMobileClick(e){
    e.stopPropagation()
    e.preventDefault()
    const currentTarget = $(e.currentTarget)
    updateCardFavourite(currentTarget, updateCardMobileFavouriteUI, 'book')
}

function manageFavouriteArticleCardClick(e){
    e.stopPropagation()
    e.preventDefault()
    const currentTarget = $(e.currentTarget)
    updateCardFavourite(currentTarget, updateCardFavouriteUI, 'article')
}

function manageFavouriteArticleCardMobileClick(e){
    e.stopPropagation()
    e.preventDefault()
    const currentTarget = $(e.currentTarget)
    updateCardFavourite(currentTarget, updateCardMobileFavouriteUI, 'article')
}

export const attachUpdateBookCardFavourite = function(){
    const els = document.getElementsByClassName(favouriteCardClass)
    for (const el of els) {
        // do not use anonymous function,
        // If the function or object is already in the list of event listeners for this target, the function or object is not added a second time.
        el.addEventListener("click", manageFavouriteCardClick);
    }
}

export const attachUpdateBookCardMobileFavourite = function(){
    const els = document.getElementsByClassName(favouriteCardMobileClass)
    for (const el of els) {
        // do not use anonymous function,
        // If the function or object is already in the list of event listeners for this target, the function or object is not added a second time.
        el.addEventListener("click", manageFavouriteCardMobileClick);
    }
}

export const attachUpdateArticleCardFavourite = function(){
    const els = document.getElementsByClassName(favouriteArticleCardClass)
    for (const el of els) {
        // do not use anonymous function,
        // If the function or object is already in the list of event listeners for this target, the function or object is not added a second time.
        el.addEventListener("click", manageFavouriteArticleCardClick);
    }
}

export const attachUpdateArticleCardMobileFavourite = function(){
    const els = document.getElementsByClassName(favouriteArticleCardMobileClass)
    for (const el of els) {
        // do not use anonymous function,
        // If the function or object is already in the list of event listeners for this target, the function or object is not added a second time.
        el.addEventListener("click", manageFavouriteArticleCardMobileClick);
    }
}

export const getCurrentAction = function(element){
    let action = addAction
    if (element.hasClass(removeClass)){
        action = removeAction
    }
    return action
}

export const getAddAction = function(){
    return addAction;
}

export const getRemoveAction = function(){
    return removeAction;
}

export const getFavouriteElementId = function(element){
    return element.data(dataElementId);
}

// for button in detail page
export function updateFavouriteUI(el, newAction) {
    const addAction = getAddAction()
    const removeAction = getRemoveAction()
    
    const selector = "[data-elementid='"+el.data('elementid')+"']"
    const tooltip = Tooltip.getInstance(selector)
    
    if (tooltip){
        const titles = {};
        titles[addAction] = el.data(dataAddTitle);
        titles[removeAction] = el.data(dataRemoveTitle);
        const newTitle = titles[newAction];
        tooltip.setContent({ '.tooltip-inner': newTitle })    
    }
    
    if (newAction == addAction) {
        el.removeClass(removeClass)
        el.addClass(addClass)
    }else{
        el.removeClass(addClass)
        el.addClass(removeClass)
    }
}

export function updateMobileCardFavouriteStatus(elId, status){
    const mobileElToUpdate = $(".mobile-actions").filter(function() {
      return $(this).data("elid") === elId;
    });
    mobileElToUpdate.data('status', status)
}

export function updateCardFavouriteUI(el, newAction, elId) {
    const addAction = getAddAction()
    let mobileStatus = 1
    if (newAction == addAction) {
        mobileStatus = 0
        el.removeClass(removeClass)
        el.addClass(addClass)
    }else{
        el.removeClass(addClass)
        el.addClass(removeClass)
    }
    updateMobileCardFavouriteStatus(elId, mobileStatus)
}

function updateCardMobileFavouriteUI(el, newAction, elId) {
    const addAction = getAddAction()
    const desktopElToUpdate = $(".add-favourite-card").filter(function() {
      return $(this).data("elementid") === elId;
    });
    let mobileStatus = 1
    if (newAction == addAction) {
        mobileStatus = 0
        el.removeClass(removeClass)
        el.addClass(addClass)
        // TODO check where it is used
        desktopElToUpdate.removeClass(removeClass)
        desktopElToUpdate.addClass(addClass)
    }else{
        el.removeClass(addClass)
        el.addClass(removeClass)
        // TODO check where it is used
        desktopElToUpdate.removeClass(addClass)
        desktopElToUpdate.addClass(removeClass)
    }
    updateMobileCardFavouriteStatus(elId, mobileStatus)
}

export function updateMobileFavouriteUI(el, newAction){
    const mobileText = $(".library-text-mobile").find('p')
    if (newAction == getAddAction()){
        mobileText.text(el.data(dataAddTitle))
    }else{
        mobileText.text(el.data(dataRemoveTitle))
    }
}